import { render, staticRenderFns } from "./LifeBuoyIcon.vue?vue&type=template&id=d2658324&"
import script from "./LifeBuoyIcon.vue?vue&type=script&lang=js&"
export * from "./LifeBuoyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports